import { useState, useEffect } from "react";

/**
 * Shared connectivity check hook
 * Monitors browser online/offline status and performs periodic public connectivity checks
 * Used by both Footer and OfflineOverlay to avoid duplicate network requests
 */
export const useConnectivityCheck = () => {
  const [browserOnline, setBrowserOnline] = useState(navigator.onLine);
  const [connectivityCheckFailed, setConnectivityCheckFailed] = useState(false);

  // Periodic connectivity check to public server
  // DISABLED: any external fetch triggers Chrome shared_dict CORS spam in console
  const checkPublicConnectivity = async () => {
    return true;
  };

  useEffect(() => {
    // Browser online/offline event listeners
    const handleOnline = () => {
      console.log("🌐 Browser online detected");
      setBrowserOnline(true);
      setConnectivityCheckFailed(false);
    };

    const handleOffline = () => {
      console.log("🌐 Browser offline detected");
      setBrowserOnline(false);
      setConnectivityCheckFailed(true);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    // Periodic connectivity check
    const connectivityInterval = setInterval(async () => {
      if (browserOnline) {
        await checkPublicConnectivity();
      }
    }, 60000); // Check every 10 seconds

    // Initial check
    if (browserOnline) {
      checkPublicConnectivity();
    }

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      clearInterval(connectivityInterval);
    };
  }, [browserOnline]);

  return {
    browserOnline,
    connectivityCheckFailed,
  };
};
